import { Flex, Text } from '@chakra-ui/react'
import { useEffect } from 'react'

import {
  type ArticleFiltersT,
  type FilterItemT,
  SelectedFiltersT,
  useArticleFilters,
} from 'utils/useArticleFilters'
import { IBaseView } from 'interfaces/navigationPage.interface'
import { MultiSelectDropdown } from 'components/MultiSelect'

function generateOptions(
  options: FilterItemT[],
  selected: {
    label: string
    value: string
  }[]
) {
  return options
    .filter((item) => !item.disabled)
    .map((op) => ({
      label: op.label,
      value: op.id,
      isSelected: selected.some((item) => item.value === op.id),
    }))
    .sort((a, b) => {
      if (a.isSelected && !b.isSelected) return -1
      if (!a.isSelected && b.isSelected) return 1
      return a.label.localeCompare(b.label)
    })
}

export function ArticlesFilters({
  filtersCB,
  view,
  availableFilters = [
    'diseases',
    'locations',
    'orgs',
    'candidates',
    'pathogenTypes',
    'techTypes',
  ],
  fixedFilter,
}: {
  filtersCB: (filters: any) => void
  view: IBaseView<any, any>
  availableFilters?: string[]
  fixedFilter?: [keyof SelectedFiltersT, string | number]
}) {
  const { options, selected, updateFilter } = useArticleFilters(
    view,
    fixedFilter
  )

  const allDropdowns: { label: string; value: keyof ArticleFiltersT }[] = [
    { label: 'Diseases', value: 'diseases' },
    { label: 'Location', value: 'locations' },
    { label: 'Organisations', value: 'orgs' },
    { label: 'Candidates', value: 'candidates' },
    { label: 'Pathogens', value: 'pathogenTypes' },
    { label: 'Tech Types', value: 'techTypes' },
    { label: 'Tag', value: 'tags' },
  ]

  const dropdowns = allDropdowns.filter((dropdown) =>
    availableFilters.includes(dropdown.value)
  )

  useEffect(() => {
    filtersCB(selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <Flex gap={0} alignItems='center' flexWrap={'wrap'}>
      {dropdowns.map((item) => (
        <Flex flexDir='column' key={item.value}>
          <Text fontWeight='normal' fontSize='xs' minW='fit-content'>
            {item.label}:
          </Text>
          <MultiSelectDropdown
            value={selected[item.value]}
            updateFilter={(options: any) => updateFilter(item.value, options)}
            options={generateOptions(options[item.value], selected[item.value])}
          />
        </Flex>
      ))}
    </Flex>
  )
}
